<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="outStockDeliveryDetails"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button v-if="submitAuth" type="primary" :disabled="!selection.length" @click="submit"> 审核</el-button>
        <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>
        <el-button v-if="printAuth" type="primary" :disabled="!selection.length" @click="printOutStockOrder">
          打印
        </el-button>
        <el-button v-if="labelPrintAuth" type="primary" :disabled="selection.length !== 1" @click="printLabel">
          打印标签
        </el-button>
        <el-button v-if="labelPrintAuth" type="primary" :disabled="selection.length !== 1" @click="transferEdit">
          物流信息
        </el-button>
        <el-button v-if="limits.delAuth" type="danger" :disabled="!selection.length" @click="deleteBatch">
          批量删除
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="出库单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="发货单号">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="最终客户">
            <el-input v-model.trim="filter.finalCustomerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择">
              <el-option label="草稿" :value="0"/>
              <el-option label="待确认" :value="1"/>
              <el-option label="已出库" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="要求日期">
            <el-date-picker
                v-model="requireDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <out-stock-delivery-edit ref="editPage" @save-success="loadData(1)"/>
    <print-out-stock-order-modal ref="printOutStockDelivery"/>
    <delivery-notice-label ref="deliveryNoticeLabel"/>
    <out-stock-transfer-edit ref="transferEdit" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import OutStockDeliveryEdit from "./OutStockDeliveryEdit";
  import PrintOutStockOrderModal from "@/views/StoreManagement/OutStockDelivery/PrintOutStockDelivery";
  import DeliveryNoticeLabel from "./DeliveryNoticeLabel";
  import OutStockTransferEdit from "@/views/StoreManagement/OutStockDelivery/OutStockTransferEdit";

  export default {
    name: "OutStockDeliveryDetailList",
    components: {
      viewTable,
      OutStockDeliveryEdit,
      PrintOutStockOrderModal,
      DeliveryNoticeLabel,
      OutStockTransferEdit,
    },
    data() {
      return {
        ids: [],
        pkids: [],
        selection: [],
        requireDateRange: [],
        createDateRange: [],
        printAuth: this.$auth(308),
        submitAuth: this.$auth(306),
        cancelAuth: this.$auth(307),
        labelPrintAuth: this.$auth(405),
        limits: {
          // addAuth: this.$auth(299),
          delAuth: this.$auth(309),
          editAuth: this.$auth(313),
        },
        filter: {
          billNo: "",
          status: "",
          relBillNo: "",
          requireDateBegin: "",
          requireDateEnd: "",
          createTimeBegin: "",
          createTimeEnd: "",
          creatorName: "",
          customerName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          finalCustomerName: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.editPage.open(params.row.masterId, true);
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            fixed: "right",
            slot: "action",
          },
        ],
      };
    },

    watch: {
      "filter.requireDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.requireDateRange = [];
            this.requireDateRange.push(this.filter.requireDateBegin);
            this.requireDateRange.push(this.filter.requireDateEnd);
          }
        },
      },
      "filter.createTimeBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createTimeBegin);
            this.createDateRange.push(this.filter.createTimeEnd);
          }
        },
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.editPage.open(row.masterId);
      },

      selectHandle(selection) {
        this.ids = [];
        this.pkids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.masterId);
          this.pkids.push(item.pkid);
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 提交
      submit() {
        // const arr = this.selection.filter((item) => item.status !== 0);
        // if (arr.length) {
        //   this.$confirm("请选择未提交的订单", "错误", {
        //     type: "error",
        //     showCancelButton: false,
        //   });
        // } else {
        this.$confirm("确定审核吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "outStockDeliverys/approve", this.ids).then(() => {
            this.loadData(1);
            // this.$message.success("审核成功");
            this.selection = [];
          });
        });
        // }
      },

      // 撤销
      repeal() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "outStockDeliverys/cancel", this.ids).then(() => {
              this.loadData(1);
              // this.$message.success("撤销成功");
              this.selection = [];
            });
          });
        }
      },

      // 打印出库单
      printOutStockOrder() {
        const arr = this.selection.filter((item) => item.status == 0);
        if (arr.length) {
          this.$confirm("请选择已提交或已出库的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.printOutStockDelivery.open(this.pkids);
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "outStockDeliverys", row.masterId).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteBatch() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择草稿状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "outStockDeliverys/deleteBatch", this.ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
      transferEdit() {
        const labelData = {
          pkId: this.selection[0].masterId,
          transferCompany: "广昌县恒达（彤宏）物流有限公司",
          transferWeight: "",
          transferNo: "",
          transferNote: "",
        };
        this.contentLoading = true;
        this.$http
            .get("basic", `outStockDeliverys/${labelData.pkId}`)
            .then((resp) => {
              if (resp.success) {
                labelData.transferCompany = resp.data.transferCompany;
                labelData.transferWeight = resp.data.transferWeight;
                labelData.transferNo = resp.data.transferNo;
                labelData.transferNote = resp.data.transferNote;
                this.contentLoading = false;
                this.selection = [];
              }
            })
            .catch(() => {
              this.contentLoading = false;
            });

        this.$refs.transferEdit.open(labelData);
      },
      printLabel() {
        const labelData = {
          customerNo: this.selection[0].customerOuterNo,
          billNo: this.selection[0].erpSourceBillNo,
          materialName: this.selection[0].materialName,
          quantity: this.selection[0].quantity,
          specification: this.selection[0].specification,
          amount: "",
          note: this.selection[0].orderNote,
          date: this.$moment().format("yyyy-MM-DD"),
          manufactor: "上海鸿康电器有限公司",
          telephone: "021-37701209",
        };
        if (this.selection[0].finalCustomerOuterNo && (this.selection[0].customerOuterNo == "SH.615" || this.selection[0].customerOuterNo == "03.009")) {
          labelData.customerNo = this.selection[0].finalCustomerOuterNo;
        }
        this.$refs.deliveryNoticeLabel.open(labelData);
      },

      otherAuth(row) {
        if (row.status === 1 || row.status === 2) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
            delAuth: false,
          };
        }
      },
    },
  };
</script>

<style>

</style>